const gerarPaginacao = (
  active = true,
  lastPage,
  currentPage,
  action,
  type = 1
) => {
  return { active, lastPage, currentPage, action, type }
}
export default gerarPaginacao
